import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'

import BlockTitle from 'components/BlockTitle'

import style from './HighlightedPartner.style'

const HighlightedPartnerStyled = styled.div(props => ({ ...style(props) }))

const HighlightedPartner = ({ t }) => {
    return (
        <HighlightedPartnerStyled>
            <div className="highlightedPartner">
                <div className="highlightedPartner__image">
                    <img src="/logo/princess-big.svg" alt="Princess logo" />
                </div>
                <BlockTitle
                    title={t('highlighted-partner-title')}
                    subtitle={t('highlighted-partner-subtitle')}
                    paddingLeft={0}
                />
            </div>
        </HighlightedPartnerStyled>
    )
}

HighlightedPartner.propTypes = {
    t: PropTypes.func.isRequired
}

export default withTranslation()(withTheme(HighlightedPartner))
